var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3373",
  "data-name": "Group 3373",
  transform: "translate(-474 -496)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Right_Icon_Background",
  cx: 6,
  cy: 6,
  r: 6,
  transform: "translate(474 496)",
  fill: "#c70c3c"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3372",
  "data-name": "Group 3372",
  transform: "translate(495.91 -192.49) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M278,2125.561v6",
  transform: "translate(202 -1626.061)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M278,2125.561v6",
  transform: "translate(2608.561 224.5) rotate(90)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1
})))));
export default __webpack_public_path__ + "static/media/wrong_check.506a9b74.svg";
export { SvgComponent as ReactComponent };